<template>	
<div class="container">	
    <img  src="../../assets/survey.png" class="topimg"/>
    <div class="ratingbox"> 
        <van-row>
            <van-col span="24">
                <van-cell title="服务单号码：" :value="soNumber" />
            </van-col>           
        </van-row>
        <van-row>
            <van-col span="24">
                <van-cell title="报修机型：" :value="printerModel" />
            </van-col>           
        </van-row>        
        <van-row>
            <van-col span="24">
                <van-cell title="服务站：" :value="staName" />
            </van-col>           
        </van-row> 
        <van-row>
            <van-col span="24">
                <van-cell title="完成日期：" :value="fixedDate" />
            </van-col>           
        </van-row>   
    </div>	 
        <div class="questionbox">    
        <van-divider contentPosition="left">您对本次维修服务总体满意度？</van-divider>
        <van-row class="pc">
            <van-col span="24"><small>（☆=非常不满意；☆☆☆☆☆=非常满意 ）</small></van-col>
        </van-row>
        <van-row>
            <van-col span="16" offset="8"><van-rate v-model ="rating[0]" @change="onChange0" class="itemstar"/> </van-col>
        </van-row>
        <van-divider contentPosition="left">服务过程评价，满意请给5星哦！</van-divider>        
        <van-row>
            <van-col span="8">服务态度</van-col>
            <van-col span="16"><van-rate v-model ="rating[1]" @change="onChange1" class="itemstar"/>  </van-col>
        </van-row> 
        <van-row>
            <van-col span="8">服务便捷度</van-col>
            <van-col span="16"><van-rate  v-model ="rating[2]" @change="onChange2" class="itemstar"/>  </van-col>
        </van-row> 
        <van-row>
            <van-col span="8">维修时长</van-col>
            <van-col span="16"><van-rate  v-model ="rating[3]" @change="onChange3" class="itemstar"/>  </van-col>
        </van-row> 
        <van-row>
            <van-col span="8">服务态度</van-col>
            <van-col span="16"><van-rate  v-model ="rating[4]" @change="onChange4" class="itemstar"/>  </van-col>
        </van-row> 
        <van-row>
            <van-col span="8">吐槽&表扬</van-col>
        </van-row>  
        <van-row>
            <van-col span="24">
                <van-field 
                clearable
                v-model = "comments" 
                placeholder="请输入您的意见" 
                type="textarea"            
                autosize
                />
            </van-col>
        </van-row>  
        <van-row class="pc">
            <p>您的反馈是我们努力的方向和动力</p>
        </van-row>        
        <van-row class="pc">
            <van-button round type="primary" block color="#707070" @click="submit">提交反馈</van-button>
        </van-row>        
    </div>	  
</div>
</template>
<script>
import { Dialog } from 'vant';
import QS from 'qs'
import Vue from 'vue'
export default {
	  name: 'survey',	 
	  data(){
	  		return{		
	  		    headerimg: require('@/assets/survey.png'),
                rating:[0,0,0,0,0],
                comments:'',
                soNumber:'',
                printerModel:'',
                guarantee:'',
                staName:'',
                sn:'',
                fixedDate:'',
                access_token:'',
                idlink:''
	  		}  	 
		},
        created(){          
           let id = this.$route.query.id         
           this.idlink = id.substring(0,32)
           this.access_token = id.substring(32,64)
           console.log(id, this.idlink, this.access_token)
           this.getorderinfo(this.idlink)
        },
        mounted(){
		document.title = '维修满意度调研';  
	    },
        methods:{            
            onChange0(event) {
                this.rating[0] = event              
            },
            onChange1(event) {
                this.rating[1] = event              
            },
            onChange2(event) {
                this.rating[2] = event              
            },
            onChange3(event) {
                this.rating[3] = event              
            },
            onChange4(event) {
                this.rating[4] = event              
            },
            submit(){
                Dialog.alert({ message: '提示' });
            },
            getorderinfo(idlink){
                let that = this
                let url = 'https://t3.lenovoimage.com/api/pdsm/bizorderinfo';
                let myparams = {
                    id: idlink
                };
                let myheaders = {
                    'Authorization': this.access_token
                }
		        // START GET
                Vue.axios.get(
                    url,
                    {
                        headers: myheaders,
                        params: myparams
                    }
                )
                .then(function (response) {
                console.log("ddd", response.data)
                if (response.data.Data.length > 0)
                {                    
                    that.soNumber = response.data.Data[0]["OrdID"]; 	
                    that.printerModel = response.data.Data[0]["model"]; 	
                    that.guarantee = response.data.Data[0]["guarantee"]; 
                    that.fixedDate = response.data.Data[0]["fixedtime"].substring(0,10); 
                    that.staName = response.data.Data[0]["staFullName"]; 
                    that.sn = response.data.Data[0]["serilcode"]; 
                }
                 })
                .catch(function (error) {
                console.log(error);
                }) 		
            },
            checkInput(){
                if (this.rating[0] == 0) return false;
                if (this.rating[1] == 0) return false;
                if (this.rating[2] == 0) return false;
                if (this.rating[3] == 0) return false;
                if (this.rating[4] == 0) return false;
                return true;                
            },
            submit(){
                let that = this    
                if (that.checkInput()){
				Dialog.confirm({ message: '确认发送服务调研' }).then(() =>
                {                         		
			        var data = QS.stringify({
                    idlink: that.idlink,
                    orderid:that.soNumber,
                    q0: that.rating[0],
                    q1: that.rating[1],
                    q2: that.rating[2],
                    q3: that.rating[3],
                    q4: that.rating[4],
                    comments: that.comments,		
                    });					 
			 	console.log(data)
                var postUrl = that.global.BASE_URL_T3 + '/api/pdsm/appendusersurvey';			  
                var config = {
                    method: 'post',
                    url: postUrl,	
                    async:false,	
                    headers: { 
                    'Authorization': that.access_token, 
                    'Content-Type': 'application/x-www-form-urlencoded'
                    },
                    data : data
                };
			  
                Vue.axios(config)
                .then(function (response) {

                    console.log("XXX" + JSON.stringify( response.data ));
                    
                    if (response.data.Status == '0')
                    {
                    that.disabled = true;				
                    Dialog.alert({ message: '服务单反馈完成感谢您的参与。' });
                    that.$router.push({ path:'/srso'  })				
                    }
                    else
                    {                      
                        Dialog.alert({
                            message: '提交失败请稍后重试。'
                        })
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });		
			  
			    })
            }      
        }
    }
}
</script>
<style>
.pc {
    text-align: center;
}
.container {
    margin:0 auto;
    padding: 0 auto;
    height: 100vh;
    background-color: white;
}
.lable {
    width:100 rpx;
    text-align: left;
}
.topimg {
    width: 100%;
}
.itemstar {
    margin:10px;
}
.ratingbox{
    text-align: left;
    margin-left:10px;
    margin-right:10px;
}
.questionbox{
    text-align: left;
    margin-left:20px;
    margin-right:20px;
    font-size: 14px;
}
</style>
